import React from "react";
import {createRoot} from "react-dom/client";
import {BrowserRouter} from "react-router-dom";

import {GTMProvider} from "./GTMProvider";
import AuthProviderWrapper from "./AuthProviderWrapper";
import AuthorizedRoutes from "./routes/authorized-routes";
import AuthorizedComponent from "./authorized-component";
import AuthProviderBridge from "./AuthProviderBridge";
import ErrorBoundary from "./components/errorBoundary/ErrorBoundary";

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
    <BrowserRouter>
        <AuthProviderWrapper>
            <AuthProviderBridge/>
            <GTMProvider/>
            <ErrorBoundary>
                <AuthorizedComponent>
                    <AuthorizedRoutes/>
                </AuthorizedComponent>
            </ErrorBoundary>
        </AuthProviderWrapper>
    </BrowserRouter>
);